
/**
 * Action type to set the ID of the active modal (or undefined if needs to be hidden).
 */
export const SET_ACTIVE_MODAL_ID = 'SET_ACTIVE_MODAL_ID';
